import { Box, styled } from '@material-ui/core';
import { SButton } from '@setvi/shared/components';
import { AIGradientBgColor } from '@setvi/shared/components/intelligence/styled';

export const Container = styled(Box)({
  display: 'flex',
  flexDirection: 'column-reverse', // Textarea expands upwards
  alignItems: 'flex-start',
  minWidth: 300,
  minHeight: 40,
  border: ({ error }: { error: boolean }) =>
    `1px solid  ${error ? 'red' : '#ccc'}`,
  padding: 5,
  borderRadius: 20,
  overflow: 'hidden',
  position: 'relative',
  background: 'white'
});

export const Actions = styled(Box)({
  width: '100%',
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: ({ error }: { error: boolean }) =>
    error ? 'space-between' : 'flex-end'
});

export const SubmitButton = styled(SButton)({
  background: AIGradientBgColor,
  borderRadius: 120,
  maxHeight: 'max-content',
  fontWeight: 500,

  '&.Mui-disabled': {
    color: '#AFBAC6',
    background: '#EEF0F2',
    '& svg path': {
      fill: '#AFBAC6'
    }
  }
});
